module.exports = __webpack_public_path__ + "img/top.116dd1d6.svg";